import React from 'react';
import '../CampanaInfo/CampanaInfo.css';
import parse from 'html-react-parser';
const Opcion2 = (props) => {
  const {
         disponible,
         estado,
         askForVote,
         nombre,
         descripcion,
         pregunta1,
         pregunta2,
         idCandidato1,
         idCandidato2,
         Opcion1,
         Opcion2,
         id
       } = props;



  return (
    <li className="cards_item" key={id}>
      <div className="card" style={{ backgroundImage: "url(/fondos/Fondo5.jpg)" }}>
        <h2 className="card_title">{nombre}</h2>
        <div className="card_text">
          {parse(descripcion)}
        </div>
        <center>
          <button
            disabled={estado === "Allow" && disponible > 0 ? "" : "disabled"}
            className={estado === "Allow" && disponible > 0 ? "button-candidate button-candidate-double" : "button-candidate-disabled button-candidate-double"}
            onClick={e => askForVote(idCandidato1, pregunta1, e, Opcion1)}
          >
            {Opcion1}
          </button>
          <button
            disabled={estado === "Allow" && disponible > 0 ? "" : "disabled"}
            className={estado === "Allow" && disponible > 0 ? "button-candidate button-candidate-double no-botton" : "button-candidate-disabled button-candidate-double"}
            onClick={e => askForVote(idCandidato2, pregunta2, e, Opcion2)}
          >
            {Opcion2}
          </button>
        </center>
      </div>
    </li>
  );
};

export default Opcion2;
